// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
body {
  overflow-y: scroll !important; }

.psuedo-link {
  cursor: pointer; }

.helper-text-wrapper {
  display: grid; }

.helper-text-mobile {
  position: relative;
  top: 16%;
  left: 8%;
  pointer-events: none; }

.helper-text-button, .helper-text-mobile {
  grid-area: 1/1; }

i.fa.fa-question {
  color: #4330ff;
  font-size: 13px;
  position: absolute;
  pointer-events: fill; }
  i.fa.fa-question.question-larger {
    font-size: 20px; }

@media screen and (min-device-width: 992px) {
  .logoImageWide {
    display: block; }
  .logoImageStacked {
    display: none; } }

@media screen and (max-device-width: 991px) and (min-device-width: 768px) {
  .logoImageWide {
    display: none; }
  .logoImageStacked {
    display: block; } }

@media screen and (max-device-width: 767px) {
  .logoImageWide {
    display: block; }
  .logoImageStacked {
    display: none; } }

.virtual-portal-header {
  display: flex;
  flex: 1 1;
  width: 100%;
  background-color: #002856;
  min-height: 100px;
  align-items: start;
  box-shadow: 1px 5px 8px 0px #9c9898; }
  .virtual-portal-header .container {
    white-space: pre-wrap;
    grid-template-columns: 30% 50% 20%;
    grid-gap: 7px;
    display: grid;
    cursor: default;
    color: #ffffff;
    padding-top: 25px;
    position: relative; }
    .virtual-portal-header .container .logo img {
      margin: 10px 0 0;
      width: 179px;
      max-width: 179px;
      height: auto; }
    .virtual-portal-header .container .title .centered {
      margin: 0 0 0 0; }
      .virtual-portal-header .container .title .centered h4 {
        font-size: 24px; }
      .virtual-portal-header .container .title .centered h5 {
        font-weight: 100;
        font-size: 18px;
        margin-top: -5px; }
    .virtual-portal-header .container .info {
      display: inline-block;
      position: relative; }
      .virtual-portal-header .container .info a {
        float: right;
        background-color: #ffffff;
        padding: 1px 10px;
        border-radius: 50%;
        color: #4330ff;
        font-weight: 900;
        margin-right: 15px; }
        .virtual-portal-header .container .info a:hover {
          text-decoration: none; }
      .virtual-portal-header .container .info .user-profile-image {
        max-height: 27px;
        max-width: 27px; }
        .virtual-portal-header .container .info .user-profile-image:hover {
          cursor: pointer; }
      .virtual-portal-header .container .info .menu {
        width: 236px;
        position: absolute;
        top: 75px;
        right: 0;
        background: #ffffff;
        color: #282829;
        z-index: 999;
        padding: 26px;
        box-shadow: 2px 5px 7px 0px #bfbdbd; }
        .virtual-portal-header .container .info .menu .menu-subheader {
          color: #c0c0c0;
          font-size: 14px;
          line-height: 22px;
          letter-spacing: .88px;
          font-weight: 400; }
        .virtual-portal-header .container .info .menu .menu-name {
          white-space: pre-wrap;
          overflow-wrap: break-word; }
        .virtual-portal-header .container .info .menu .menu-title {
          white-space: pre;
          margin-bottom: 0; }
        .virtual-portal-header .container .info .menu .menu-title {
          color: #909092;
          font-size: 12px;
          line-height: 22px;
          letter-spacing: .88px;
          text-transform: uppercase; }
        .virtual-portal-header .container .info .menu hr {
          margin: 2rem 0; }
        .virtual-portal-header .container .info .menu ul, .virtual-portal-header .container .info .menu .menu-item {
          list-style-type: none;
          list-style-position: inside;
          margin: 0.5rem 0;
          letter-spacing: .88px;
          padding: 0;
          font-size: 14px; }
          .virtual-portal-header .container .info .menu ul a, .virtual-portal-header .container .info .menu .menu-item a {
            font-weight: 400;
            margin: 0;
            float: none;
            padding: 0;
            color: #606060; }
        .virtual-portal-header .container .info .menu .menu-item, .virtual-portal-header .container .info .menu a:hover {
          font-weight: 600;
          cursor: pointer;
          color: #4330ff; }

.welcome {
  margin: 5px 0 30px; }
  .welcome h2 {
    color: #282829;
    font-size: 40px; }
  .welcome h5 {
    color: #606060;
    text-transform: uppercase;
    letter-spacing: .88px;
    font-size: 14px; }

.alert-section {
  height: auto; }
  .alert-section .header-alert {
    background: #fa504b;
    color: #ffffff;
    width: auto;
    display: inline-block;
    padding: 10px 15px;
    margin-right: 10px;
    font-size: 1rem;
    border-radius: 0px 0px 3px 3px; }
    .alert-section .header-alert.gray {
      background: #606060; }
    .alert-section .header-alert:hover {
      text-decoration: none;
      cursor: pointer; }
    .alert-section .header-alert .fa {
      font-size: 36px;
      vertical-align: middle;
      padding: 0 0 1px 10px; }

.emergency-broadcast-section {
  height: auto;
  width: 100%;
  max-width: none !important;
  box-shadow: 1px 5px 8px 0px #9c9898;
  margin-bottom: 5px; }
  .emergency-broadcast-section .header-emergency-broadcast {
    background: #fa504b;
    color: #ffffff;
    width: 100%;
    padding: 10px 15px;
    font-size: 1.2rem; }
  .emergency-broadcast-section .body-emergency-broadcast {
    font-size: 1rem; }

.no-agenda {
  min-height: calc(100vh - 225px);
  padding-top: 50px; }
  .no-agenda h1, .no-agenda h4 {
    color: #2C2C2C; }
  .no-agenda h4 {
    font-weight: 600; }
  .no-agenda h5 {
    text-transform: uppercase;
    color: #606060;
    font-size: 14px;
    letter-spacing: .8px; }
  .no-agenda p {
    color: #606060;
    font-size: 18px;
    margin-top: 20px;
    font-weight: 100; }
    .no-agenda p a {
      text-decoration: underline; }

.virtual-sessions-page .session-advisory {
  color: #606060; }

.virtual-sessions-page button.filter-tabs {
  border: 2px solid #4330ff;
  min-width: 250px;
  cursor: pointer;
  border-radius: 3px;
  padding: 0; }
  .virtual-sessions-page button.filter-tabs .my-schedule, .virtual-sessions-page button.filter-tabs .agenda {
    font-size: 1rem;
    width: 50%;
    background: #ffffff;
    color: #4330ff;
    width: 50%;
    float: left;
    padding: 4px; }
    .virtual-sessions-page button.filter-tabs .my-schedule.active, .virtual-sessions-page button.filter-tabs .agenda.active {
      background: #4330ff;
      color: #ffffff; }
  .virtual-sessions-page button.filter-tabs:focus {
    outline-color: #4330ff; }

.virtual-sessions-page .session-link {
  width: calc(100% - 100px); }
  .virtual-sessions-page .session-link:hover {
    text-decoration: none; }

.virtual-sessions-page .session-icons {
  position: inherit;
  display: grid;
  max-height: 184px;
  right: 10px; }
  .virtual-sessions-page .session-icons button {
    vertical-align: middle;
    margin: auto;
    margin-right: 0px; }
  .virtual-sessions-page .session-icons .editp2plink {
    display: grid;
    text-decoration: none; }
  .virtual-sessions-page .session-icons .editp2p {
    border-radius: 5px;
    font-size: 14px;
    line-height: 1rem;
    padding: 10px 3px;
    border: 2px solid #fa504b;
    color: #fa504b;
    vertical-align: middle;
    background-color: transparent; }
    .virtual-sessions-page .session-icons .editp2p.btn-danger {
      color: #ffffff; }
    .virtual-sessions-page .session-icons .editp2p:hover {
      border-color: #fb736f;
      background-color: #fb736f;
      color: #ffffff; }
    .virtual-sessions-page .session-icons .editp2p:focus {
      outline: none;
      box-shadow: none; }

.virtual-sessions-page .time-block-section {
  background: #eaeaea;
  margin: 30px 0;
  padding: 10px;
  font-size: .8rem;
  color: #002856;
  font-weight: 600;
  border-radius: 3px; }
  .virtual-sessions-page .time-block-section p.formatted-time {
    margin: 20px 0;
    font-weight: 700;
    font-size: 14px;
    text-transform: uppercase; }

.virtual-sessions-page .day-break {
  border-top: 2px dashed #909092; }

.virtual-sessions-page .session {
  grid-template-columns: 17% 68% 15%;
  display: grid;
  background: #ffffff;
  color: #282829;
  border: 0.5px solid #eaeaea;
  line-height: 10px;
  text-decoration: none;
  position: relative;
  box-shadow: 2px 2px 7px 0px #bfbdbd;
  margin: 20px 0;
  min-height: 200px;
  border-radius: 3px; }
  .virtual-sessions-page .session.itinerary {
    padding: 0 15px;
    grid-template-columns: 100%;
    min-height: 0;
    text-indent: 20px; }
    .virtual-sessions-page .session.itinerary p {
      margin: 10px;
      text-transform: uppercase;
      font-style: italic;
      font-weight: 400;
      font-size: 14px; }
  .virtual-sessions-page .session.session-over .container {
    opacity: 0.6; }
    .virtual-sessions-page .session.session-over .container p, .virtual-sessions-page .session.session-over .container h3 {
      color: #6D6E71; }
  .virtual-sessions-page .session.session-over .session-cta-wrapper {
    box-shadow: inset 0 0 0 100vw rgba(239, 239, 240, 0.78); }
    .virtual-sessions-page .session.session-over .session-cta-wrapper .registration-button {
      font-size: 1.25rem;
      border-radius: 50%;
      width: 55px;
      height: 55px; }
  .virtual-sessions-page .session .session-cta-wrapper {
    background-size: cover;
    display: flex;
    max-height: 198px; }
    .virtual-sessions-page .session .session-cta-wrapper .registration-button {
      margin: auto;
      background: #ffffff;
      border-radius: 35px;
      color: #4330ff;
      border: none;
      font-weight: 600;
      text-align: left;
      font-size: .88rem;
      padding: 10px;
      width: 75%;
      height: 60px;
      text-align: center;
      line-height: 15px; }
      .virtual-sessions-page .session .session-cta-wrapper .registration-button.registered {
        background: #4330ff;
        color: #ffffff; }
      .virtual-sessions-page .session .session-cta-wrapper .registration-button.p2pSession {
        background: #eaeaea;
        color: #606060; }
      .virtual-sessions-page .session .session-cta-wrapper .registration-button .icon-and-text {
        position: relative;
        padding-left: 30px; }
        .virtual-sessions-page .session .session-cta-wrapper .registration-button .icon-and-text i {
          position: absolute;
          font-size: 1.5rem;
          left: 10px;
          top: 3px; }
          .virtual-sessions-page .session .session-cta-wrapper .registration-button .icon-and-text i.fa-minus {
            top: -4px; }
      .virtual-sessions-page .session .session-cta-wrapper .registration-button:focus {
        outline: 0; }
    .virtual-sessions-page .session .session-cta-wrapper.not-authorized {
      box-shadow: inset 0 0 0 100vw rgba(239, 239, 240, 0.75); }
      .virtual-sessions-page .session .session-cta-wrapper.not-authorized .registration-button {
        color: #606060; }
  .virtual-sessions-page .session .container {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    padding: 15px 35px;
    margin-top: -10px; }
    .virtual-sessions-page .session .container .inner-wrapper {
      margin: auto;
      width: 100%; }
    .virtual-sessions-page .session .container .action-links {
      color: #606060;
      margin-top: 10px;
      width: 100%; }
      .virtual-sessions-page .session .container .action-links .more, .virtual-sessions-page .session .container .action-links .add-to-calendar {
        width: 50%;
        font-size: 14px; }
        .virtual-sessions-page .session .container .action-links .more:hover, .virtual-sessions-page .session .container .action-links .add-to-calendar:hover {
          cursor: pointer; }
      .virtual-sessions-page .session .container .action-links .add-to-calendar, .virtual-sessions-page .session .container .action-links .more {
        color: #6D6E71; }
        .virtual-sessions-page .session .container .action-links .add-to-calendar:hover, .virtual-sessions-page .session .container .action-links .more:hover {
          text-decoration: none; }
      .virtual-sessions-page .session .container .action-links .add-to-calendar {
        margin-left: 45px; }
      .virtual-sessions-page .session .container .action-links .fa {
        margin-right: 10px; }
  .virtual-sessions-page .session .session-time {
    background: #909092;
    color: white;
    padding: 10px; }
  .virtual-sessions-page .session .session-header .session-type {
    text-transform: uppercase;
    color: #282829;
    margin: 8px 0px;
    font-size: 14px;
    font-weight: 600; }
  .virtual-sessions-page .session .session-header .session-name {
    padding-top: 10px;
    color: #282829;
    display: block;
    display: -webkit-box;
    max-width: 100%;
    margin: -15px auto 10px;
    -webkit-line-clamp: 2;
    /* autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 26px;
    font-weight: 600; }
    .virtual-sessions-page .session .session-header .session-name.open-true {
      -webkit-line-clamp: 3; }
  .virtual-sessions-page .session .session-information {
    max-width: 900px;
    padding-top: 10px;
    color: #282829;
    line-height: 1em; }
    .virtual-sessions-page .session .session-information.hidden {
      display: none; }
    .virtual-sessions-page .session .session-information .session-body p, .virtual-sessions-page .session .session-information .session-body li {
      color: #606060;
      font-size: 17px;
      line-height: 20px;
      font-weight: 400; }
    .virtual-sessions-page .session .session-information .session-body ul {
      list-style-type: none; }
    .virtual-sessions-page .session .session-information .session-body ul > li:before {
      content: '–';
      position: absolute;
      margin-left: -1em; }
  .virtual-sessions-page .session .user-list.speaker {
    color: #282829;
    margin: 10px 0;
    text-transform: none; }
    .virtual-sessions-page .session .user-list.speaker img {
      max-width: 65px;
      height: auto; }
    .virtual-sessions-page .session .user-list.speaker .user-info {
      font-weight: 100;
      font-size: 1.2rem;
      color: #606060;
      line-height: 15px; }
      .virtual-sessions-page .session .user-list.speaker .user-info .full-name {
        font-weight: 600; }
      .virtual-sessions-page .session .user-list.speaker .user-info .speaker-type {
        text-transform: uppercase;
        font-size: .75rem;
        font-weight: 400;
        color: #000000;
        margin-top: 9px; }
      .virtual-sessions-page .session .user-list.speaker .user-info div {
        margin: 0px 0px 5px; }

.virtual-sessions-page .btn.btn-danger {
  background-color: #fa504b; }
  .virtual-sessions-page .btn.btn-danger:disabled, .virtual-sessions-page .btn.btn-danger.disabled {
    background-color: #606060;
    border-color: #606060; }
    .virtual-sessions-page .btn.btn-danger:disabled:hover, .virtual-sessions-page .btn.btn-danger.disabled:hover {
      background-color: #606060;
      border-color: #606060;
      cursor: not-allowed; }
  .virtual-sessions-page .btn.btn-danger:hover {
    background-color: #fb736f;
    border-color: #fb736f; }
  .virtual-sessions-page .btn.btn-danger.closing-details {
    margin: auto;
    display: block;
    margin-bottom: 50px; }

.header-router-footer {
  display: flex;
  flex-direction: column;
  min-height: 100vh; }

.header-router {
  flex: 1 1; }

footer.virtual-footer {
  flex-shrink: 0;
  background: #002856;
  color: #ffffff;
  padding: 15px 0; }
  footer.virtual-footer .session-closing-details {
    margin-top: 25px; }
    footer.virtual-footer .session-closing-details p {
      font-weight: 100;
      font-size: 26px; }
      footer.virtual-footer .session-closing-details p strong {
        font-weight: 600; }
    footer.virtual-footer .session-closing-details .pseudo-link {
      cursor: pointer;
      text-decoration: underline; }
  footer.virtual-footer .copyright {
    display: block;
    text-align: center;
    font-size: 14px;
    font-style: italic;
    margin: 25px auto; }
    footer.virtual-footer .copyright a {
      color: #ffffff; }

.react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal {
  padding: 45px;
  min-height: 500px;
  background-color: #ffffff; }
  .react-modal.error-modal .button-container button, .react-modal.info-modal .button-container button, .react-modal.evaluation-modal .button-container button {
    margin-top: 40px; }
  .react-modal.error-modal .pm-info > p, .react-modal.info-modal .pm-info > p, .react-modal.evaluation-modal .pm-info > p {
    margin: 0; }
  .react-modal.error-modal .live-chat-link, .react-modal.info-modal .live-chat-link, .react-modal.evaluation-modal .live-chat-link {
    color: #4330ff;
    font-weight: 600;
    cursor: pointer; }
  .react-modal.error-modal.confirm, .react-modal.info-modal.confirm, .react-modal.evaluation-modal.confirm {
    min-height: 275px; }
    .react-modal.error-modal.confirm .generic-info-modal-content p, .react-modal.info-modal.confirm .generic-info-modal-content p, .react-modal.evaluation-modal.confirm .generic-info-modal-content p {
      text-align: center; }
    .react-modal.error-modal.confirm .button-container, .react-modal.info-modal.confirm .button-container, .react-modal.evaluation-modal.confirm .button-container {
      display: flex; }
  .react-modal.error-modal .modalCancelText, .react-modal.info-modal .modalCancelText, .react-modal.evaluation-modal .modalCancelText {
    text-align: center;
    cursor: pointer;
    text-decoration: underline;
    color: #4330ff;
    font-size: 24px; }

.react-modal.evaluation-modal .header h3 {
  margin-bottom: 20px; }

.react-modal.evaluation-modal .header .fa-times-thin {
  position: absolute;
  right: 15px;
  top: 10px; }

.react-modal.evaluation-modal .evaluation-modal-content {
  margin-top: 2rem; }
  .react-modal.evaluation-modal .evaluation-modal-content .evaluation-modal-stars {
    text-align: center;
    margin: 0 3.5rem 1rem;
    display: flex;
    justify-content: space-between; }
    .react-modal.evaluation-modal .evaluation-modal-content .evaluation-modal-stars .fa.fa-star-o.unchecked {
      color: #4330ff; }
  .react-modal.evaluation-modal .evaluation-modal-content textarea.form-control {
    min-height: 90px;
    resize: none; }
    .react-modal.evaluation-modal .evaluation-modal-content textarea.form-control:focus {
      border: none;
      outline: none;
      box-shadow: none; }
  .react-modal.evaluation-modal .evaluation-modal-content ::placeholder {
    color: #c0c0c0; }
  .react-modal.evaluation-modal .evaluation-modal-content .button-container {
    text-align: center; }

.follow-up {
  padding-top: 10px;
  margin-right: 5px; }
  .follow-up .follow-up-label {
    padding-right: 20px; }
  .follow-up input {
    margin-right: 5px; }

.react-modal.generic.info-modal .generic-info-modal-header .fa-times-thin {
  position: absolute;
  right: 15px;
  top: 10px; }

.react-modal.generic.info-modal h4 {
  font-weight: 600;
  margin: 0 0 22px;
  color: #2C2C2C; }

.react-modal.generic.info-modal .fa {
  margin-right: 10px; }

.react-modal.generic.info-modal a {
  color: #4330ff;
  font-weight: 600;
  cursor: pointer; }

.react-modal.generic.info-modal .eblue-button a {
  color: #ffffff;
  font-weight: 400; }

.react-modal.generic.info-modal .button-container hr {
  margin-top: 45px; }

.react-modal.generic.info-modal .take-event-eval {
  font-weight: 400; }

.react-modal.info-pop-up {
  height: 90%; }

.react-modal.double-booking, .react-modal.troubleshooting {
  height: 70%; }

.react-modal.wishlist-user-info .generic-info-modal-content .user-list {
  color: #282829;
  margin: 10px 0;
  text-transform: none; }
  .react-modal.wishlist-user-info .generic-info-modal-content .user-list img {
    width: 110px;
    height: auto; }
  .react-modal.wishlist-user-info .generic-info-modal-content .user-list .user-info {
    font-weight: 400;
    font-size: 1.2rem;
    color: #606060;
    line-height: 20px;
    padding: 20px 0 0 10px; }
    .react-modal.wishlist-user-info .generic-info-modal-content .user-list .user-info .full-name {
      color: #282829;
      font-weight: 800; }
    .react-modal.wishlist-user-info .generic-info-modal-content .user-list .user-info div {
      margin: 0px 0px 5px; }

.react-modal.wishlist-user-info .generic-info-modal-content .bio {
  padding-top: 20px;
  color: #606060; }
  .react-modal.wishlist-user-info .generic-info-modal-content .bio p {
    margin: 0; }

.react-modal.error-modal .generic-error-modal-header .fa-times-thin {
  position: absolute;
  right: 15px;
  top: 10px; }

.closing-details .see-you-soon {
  color: #6D6E71;
  margin: 30px 0 0; }

.closing-details .thank-you-body-content {
  color: #606060; }
  .closing-details .thank-you-body-content h6 {
    font-weight: 600; }
  .closing-details .thank-you-body-content p {
    font-weight: 300; }

.closing-details .take-event-eval {
  display: block;
  margin: 25px 0; }
  .closing-details .take-event-eval .fa {
    font-weight: 600;
    font-size: 18px; }

.closing-details button:hover, .closing-details a:hover {
  text-decoration: none; }

.closing-details .upcoming-event-row {
  box-shadow: 2px 2px 7px 0px #bfbdbd;
  margin: 15px 0;
  border-radius: 3px; }
  .closing-details .upcoming-event-row .container {
    padding: 0;
    display: grid;
    grid-template-columns: 20% 55% 25%; }
    .closing-details .upcoming-event-row .container .event-image {
      background-position: center;
      background-size: cover; }
    .closing-details .upcoming-event-row .container .main-content {
      padding: 10px; }
      .closing-details .upcoming-event-row .container .main-content .event-date {
        text-transform: uppercase; }
      .closing-details .upcoming-event-row .container .main-content h5 {
        font-size: 14px;
        font-weight: 600; }
      .closing-details .upcoming-event-row .container .main-content h6 {
        font-size: 12px; }
      .closing-details .upcoming-event-row .container .main-content .learn-more {
        font-size: 12px;
        font-weight: 500; }
        .closing-details .upcoming-event-row .container .main-content .learn-more:hover {
          text-decoration: none; }
    .closing-details .upcoming-event-row .container .register-button-container {
      display: grid; }
      .closing-details .upcoming-event-row .container .register-button-container button.btn.btn-danger {
        background-color: #fa504b;
        border-color: #fa504b;
        vertical-align: middle;
        margin: auto;
        margin-right: 10px;
        padding: 0; }
        .closing-details .upcoming-event-row .container .register-button-container button.btn.btn-danger.registered {
          border-color: #606060;
          background-color: #606060; }
          .closing-details .upcoming-event-row .container .register-button-container button.btn.btn-danger.registered a {
            cursor: not-allowed; }
            .closing-details .upcoming-event-row .container .register-button-container button.btn.btn-danger.registered a .fa {
              margin: 1px; }
          .closing-details .upcoming-event-row .container .register-button-container button.btn.btn-danger.registered:hover {
            border-color: #606060;
            background-color: #606060; }
        .closing-details .upcoming-event-row .container .register-button-container button.btn.btn-danger a {
          font-size: 11px;
          color: #ffffff;
          display: block;
          padding: 6px 12px 6px;
          font-weight: 400;
          letter-spacing: .5px; }
          .closing-details .upcoming-event-row .container .register-button-container button.btn.btn-danger a:hover {
            text-decoration: none; }
        .closing-details .upcoming-event-row .container .register-button-container button.btn.btn-danger:hover {
          border-color: #fb736f;
          background-color: #fb736f; }

.btn-danger:hover {
  background-color: #fb736f;
  border-color: #fb736f; }

.btn-danger:focus {
  outline: none !important;
  box-shadow: none !important; }

.eblue-button {
  background-color: #4330ff;
  color: #ffffff;
  border: 2px solid #4330ff;
  border-radius: 5px;
  font-size: 14px;
  padding: 10px 15px;
  letter-spacing: 1.5px;
  white-space: nowrap; }
  .eblue-button:disabled {
    opacity: 0.6;
    background-color: #ffffff;
    border: 2px solid #6D6E71;
    color: #6D6E71;
    font-weight: 400; }
    .eblue-button:disabled:hover {
      border: 2px solid #6D6E71;
      background-color: inherit;
      cursor: not-allowed; }
  .eblue-button:active {
    background-color: #ffffff;
    color: #4330ff; }
  .eblue-button:hover {
    background-color: #5c4ee5;
    border-color: #5c4ee5;
    cursor: pointer; }
  .eblue-button:focus {
    outline: none; }
  .eblue-button.open-chat-window {
    margin: auto;
    display: block;
    padding: 4px 6px;
    font-size: 1rem;
    letter-spacing: inherit; }

.center-progress-display i.fa-spinner {
  color: #6D6E71; }

.fa-times-thin:before {
  content: '\\00d7';
  color: #6D6E71; }

hr {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  margin: 0 0 22px;
  color: #6D6E71; }

@media only screen and (max-width: 1200px) {
  .virtual-sessions-page .session {
    grid-template-columns: 20% 60% 20%; }
  .virtual-sessions-page .session-timeslots {
    grid-template-columns: 20% 60% 20%; } }

@media only screen and (max-width: 992px) {
  .welcome h2 {
    font-size: 42px; }
  .welcome h5 {
    font-size: 12px; }
  .virtual-sessions-page .session {
    grid-template-columns: 25% 50% 25%; }
    .virtual-sessions-page .session .session-header .session-name {
      font-size: 24px; }
    .virtual-sessions-page .session .session-header .session-type {
      font-size: 12px; }
    .virtual-sessions-page .session .session-icons {
      right: 0; }
  .virtual-sessions-page .session-timeslots {
    grid-template-columns: 25% 50% 25%; } }

@media only screen and (max-width: 767px) {
  .virtual-portal-header {
    display: inline-block; }
    .virtual-portal-header .container {
      display: block;
      position: relative;
      padding-top: 5px; }
      .virtual-portal-header .container .logo {
        width: 50%;
        float: left;
        margin-bottom: 10px; }
        .virtual-portal-header .container .logo img {
          max-width: 128px; }
      .virtual-portal-header .container .title {
        width: 100%;
        float: left;
        margin-left: 3px; }
        .virtual-portal-header .container .title .centered h4 {
          font-size: 22px; }
        .virtual-portal-header .container .title .centered h5 {
          font-size: 14px; }
      .virtual-portal-header .container .info {
        position: absolute;
        right: 10px;
        top: 15px;
        display: flex;
        flex-direction: row-reverse; }
        .virtual-portal-header .container .info .menu {
          top: 93px; }
  .alert-section .header-alert {
    font-size: .8rem; }
    .alert-section .header-alert .fa {
      font-size: 1.5rem;
      padding: 0px 0px 0px 5px;
      line-height: 5px; }
  .filter-tabs {
    width: 95%;
    margin: auto;
    display: block; }
  .welcome {
    margin: 20px auto;
    width: 95%;
    display: block; }
    .welcome h2 {
      font-size: 32px; }
  .virtual-sessions-page .time-block-section p.formatted-time {
    font-weight: 600; }
  .virtual-sessions-page .session {
    display: inherit; }
    .virtual-sessions-page .session .session-cta-wrapper {
      min-height: 115px; }
      .virtual-sessions-page .session .session-cta-wrapper .registration-button {
        margin-left: 3%;
        font-size: .75rem;
        font-weight: 400;
        max-width: 40%;
        max-height: 50px; }
    .virtual-sessions-page .session .container {
      padding: 15px 10px; }
      .virtual-sessions-page .session .container .action-links .add-to-calendar {
        margin-left: none; }
      .virtual-sessions-page .session .container .action-links .add-to-calendar, .virtual-sessions-page .session .container .action-links .more {
        float: left;
        margin: auto;
        font-size: 14px; }
      .virtual-sessions-page .session .container .session-header .session-name {
        font-size: 20px; }
      .virtual-sessions-page .session .container .session-header .session-type {
        font-size: 12px; }
    .virtual-sessions-page .session .session-icons {
      margin: 10px 0; }
      .virtual-sessions-page .session .session-icons button {
        margin-right: auto; }
      .virtual-sessions-page .session .session-icons .eblue-button {
        font-size: .8rem; }
    .virtual-sessions-page .session.itinerary p {
      margin-left: 0px;
      text-indent: 10px; }
    .virtual-sessions-page .session .session-information {
      line-height: .75em; }
      .virtual-sessions-page .session .session-information .session-body p, .virtual-sessions-page .session .session-information .session-body li {
        font-size: 14px;
        line-height: 18px;
        font-weight: 400; }
      .virtual-sessions-page .session .session-information .session-body ul > li:before {
        margin-left: -.75em; }
  .virtual-sessions-page .session-timeslots {
    grid-template-columns: unset;
    height: auto;
    text-align: center; }
    .virtual-sessions-page .session-timeslots .timeslot-btn-div {
      margin: 15px; }
    .virtual-sessions-page .session-timeslots .add-to-calendar {
      display: block;
      width: 100%;
      text-align: center;
      margin: 15px 0; }
  footer.virtual-footer p {
    font-size: 20px; }
  footer.virtual-footer .pseudo-link {
    cursor: pointer;
    text-decoration: underline; }
  footer.virtual-footer .copyright {
    font-size: 10px; }
  .closing-details .event-eval-btn {
    margin-top: 10px; }
  .closing-details .upcoming-event-row .container {
    grid-template-columns: inherit; }
    .closing-details .upcoming-event-row .container .event-image {
      display: none; }
    .closing-details .upcoming-event-row .container .register-button-container button.btn.btn-danger {
      margin: auto;
      margin-bottom: 10px; } }

.bad-token input {
  width: 75%;
  margin-bottom: 10px; }

/* ZOOM CSS */
#zmmtg-root {
  display: none; }

#wc-content {
  height: calc(100% - 122px) !important;
  bottom: -118px; }

#wc-container-right {
  height: calc(100vh - 153px) !important; }

.ReactVirtualized__Grid.ReactVirtualized__List.chat-virtualized-list {
  max-height: calc(100vh - 285px) !important; }

.ReactVirtualized__Grid__innerScrollContainer {
  max-height: calc(100vh - 320px) !important;
  overflow-y: scroll !important; }

.active-video-container__wrap {
  height: calc(100vh - 200px); }

.audio-option-menu,
.video-option-menu {
  display: none !important; }

.footer-button__button-label {
  color: white; }

#moreButton {
  display: none; }

.send-video-container button,
.join-audio-container button {
  color: #ffffff; }

.session-timeslots {
  color: #909092;
  font-size: 12px;
  border-top: 1px dashed #909092;
  padding: 12px;
  width: 100%;
  display: grid;
  grid-template-columns: 20% 65% 15%;
  position: relative;
  top: -26px;
  background: #ffffff;
  box-shadow: 2px 2px 8px 0px #bfbdbd;
  height: 6rem; }
  .session-timeslots .full-name {
    font-weight: 900;
    font-size: 13px; }
  .session-timeslots .btn-cancel {
    border: 1px solid #909092; }
  .session-timeslots .timeslot-btn-div {
    display: grid; }
  .session-timeslots .timeslot-btn {
    align-self: center;
    padding: 5px 15px;
    margin: 0 10px;
    font-size: 14px; }
    .session-timeslots .timeslot-btn.btn-cancel {
      border: 2px solid #fa504b;
      padding: 5px 30px;
      color: #fa504b; }
      .session-timeslots .timeslot-btn.btn-cancel:hover {
        border-color: #fb736f;
        background-color: #fb736f;
        color: #ffffff; }
    .session-timeslots .timeslot-btn.btn-danger {
      color: #ffffff; }
  .session-timeslots .add-to-calendar {
    width: 50%;
    font-size: 14px;
    color: #6D6E71; }
    .session-timeslots .add-to-calendar:hover {
      cursor: pointer;
      text-decoration: none; }
    .session-timeslots .add-to-calendar .fa {
      margin-right: 10px; }

.wizard-links {
  margin-bottom: 20px;
  width: 100%;
  float: left; }
  .wizard-links .link-divider {
    color: #4330ff;
    font-weight: 100;
    line-height: 5px;
    position: relative;
    top: -3px;
    float: left;
    border-left: 2px solid #4330ff;
    width: 2px;
    height: 41px;
    display: block;
    margin: 0 12px; }
  .wizard-links .profile-nav {
    float: left; }
    .wizard-links .profile-nav .active {
      position: relative; }
    .wizard-links .profile-nav a:hover {
      text-decoration: none; }
  .wizard-links .wizard-nav {
    display: grid;
    grid-template-columns: 2fr 2fr 2fr;
    border: 2px solid #4330ff;
    border-radius: 3px;
    float: left;
    color: #4330ff; }
    .wizard-links .wizard-nav a, .wizard-links .wizard-nav div {
      text-align: center;
      white-space: pre;
      padding: 3px 15px; }
  .wizard-links a {
    color: #909092; }
    .wizard-links a.my-details {
      border: 2px solid #4330ff;
      color: #4330ff;
      background: #ffffff;
      padding: 3px 15px;
      border-radius: 3px;
      float: left; }
      .wizard-links a.my-details.active {
        background-color: #4330ff;
        color: #ffffff; }
  .wizard-links .active {
    background-color: #4330ff;
    color: #ffffff; }

.wizard-form {
  margin-top: 10px; }
  .wizard-form input, .wizard-form textarea {
    width: 100%;
    border: 1px #909092 solid;
    border-radius: 3px;
    color: #606060; }
  .wizard-form h4 {
    color: #2C2C2C; }
  .wizard-form p {
    color: #6D6E71; }
  .wizard-form .bottom-buttons {
    text-align: center; }
  .wizard-form .rounded-circle {
    margin-right: 5px; }
  .wizard-form .submit {
    color: #ffffff;
    background-color: #fa504b;
    width: 200px;
    border: 2px solid #fa504b; }
    .wizard-form .submit:disabled {
      background-color: #eaeaea;
      background-color: #eaeaea; }
      .wizard-form .submit:disabled i {
        margin-right: 10px; }
    .wizard-form .submit:focus {
      outline: none; }
    .wizard-form .submit.previous {
      color: #fa504b;
      background: #ffffff;
      border: 2px solid #fa504b; }
  .wizard-form .lps {
    width: 345px; }
  .wizard-form label {
    color: #909092;
    font-weight: normal;
    display: block;
    margin-bottom: 0; }

@media only screen and (max-width: 585px) {
  .wizard-links .link-divider {
    display: none; }
  .wizard-links .wizard-nav {
    display: block;
    margin-top: 10px; }
  .wizard-links a.my-details, .wizard-links .profile-nav {
    float: none; }
  .wishlist-rank-page .wishlistDraggable {
    text-align: center;
    display: block; }
    .wishlist-rank-page .wishlistDraggable .action-button {
      margin-top: 5px; }
  .react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal {
    min-height: 300px; }
    .react-modal.error-modal .button-container button, .react-modal.info-modal .button-container button, .react-modal.evaluation-modal .button-container button {
      margin-top: 0px; } }

@media only screen and (max-width: 992px) {
  .wizard-links a.my-details, .wizard-links .wizard-nav a, .wizard-links .wizard-nav div {
    padding: 3px;
    font-size: 12px; }
  .wizard-links .link-divider {
    height: 36px; } }
`, "",{"version":3,"sources":["webpack://./src/components/VirtualPortal/css/sessions.scss","webpack://./src/app/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,6BAA6B,EAAA;;AAE/B;EACE,eAAe,EAAA;;AAGjB;EACE,aAAa,EAAA;;AAGf;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,oBAAoB,EAAA;;AAGtB;EACE,cAAc,EAAA;;AAGhB;EACE,cCFmB;EDGnB,eAAe;EACf,kBAAkB;EAClB,oBAAoB,EAAA;EAJtB;IAMI,eAAe,EAAA;;AAInB;EACE;IACE,cAAc,EAAA;EAEhB;IACE,aAAa,EAAA,EACd;;AAGH;EACE;IACE,aAAa,EAAA;EAEf;IACE,cAAc,EAAA,EACf;;AAGH;EACE;IACE,cAAc,EAAA;EAEhB;IACE,aAAa,EAAA,EACd;;AAIH;EACE,aAAa;EACb,SAAO;EACP,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC,EAAA;EAPrC;IASI,qBAAqB;IACrB,kCAAkC;IAClC,aAAa;IACb,aAAa;IACb,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB,EAAA;IAhBtB;MAkBM,gBAAgB;MAChB,YAAY;MACZ,gBAAgB;MAChB,YAAY,EAAA;IArBlB;MAyBQ,eAAe,EAAA;MAzBvB;QA2BU,eAAe,EAAA;MA3BzB;QA8BU,gBAAgB;QAChB,eAAe;QACf,gBAAgB,EAAA;IAhC1B;MAqCM,qBAAqB;MACrB,kBAAkB,EAAA;MAtCxB;QAwCQ,YAAY;QACZ,yBAAyB;QACzB,iBAAiB;QACjB,kBAAkB;QAClB,cCnFa;QDoFb,gBAAgB;QAChB,kBAAkB,EAAA;QA9C1B;UAgDU,qBAAqB,EAAA;MAhD/B;QAoDQ,gBAAgB;QAChB,eAAe,EAAA;QArDvB;UAuDU,eAAe,EAAA;MAvDzB;QA2DQ,YAAY;QACZ,kBAAkB;QAClB,SAAS;QACT,QAAQ;QACR,mBAAmB;QACnB,cCzGQ;QD0GR,YAAY;QACZ,aAAa;QACb,mCAAmC,EAAA;QAnE3C;UAqEU,cCrHW;UDsHX,eAAe;UACf,iBAAiB;UACjB,qBAAqB;UACrB,gBAAgB,EAAA;QAzE1B;UA4EU,qBAAqB;UACrB,yBAAyB,EAAA;QA7EnC;UAgFU,gBAAgB;UAChB,gBAAgB,EAAA;QAjF1B;UAoFU,cCrIiB;UDsIjB,eAAe;UACf,iBAAiB;UACjB,qBAAqB;UACrB,yBAAyB,EAAA;QAxFnC;UA2FU,cAAc,EAAA;QA3FxB;UA8FU,qBAAqB;UACrB,2BAA0B;UAC1B,gBAAe;UACf,qBAAqB;UACrB,UAAS;UACT,eAAe,EAAA;UAnGzB;YAqGY,gBAAgB;YAChB,SAAQ;YACR,WAAW;YACX,UAAS;YACT,cCxJc,EAAA;QD+C1B;UA6GU,gBAAgB;UAChB,eAAe;UACf,cCtJW,EAAA;;AD8JrB;EACE,kBAAkB,EAAA;EADpB;IAGI,cCnKY;IDoKZ,eAAe,EAAA;EAJnB;IAOI,cC7KsB;ID8KtB,yBAAyB;IACzB,qBAAqB;IACrB,eAAe,EAAA;;AAInB;EACE,YAAY,EAAA;EADd;IAGI,mBC3KW;ID4KX,cAAc;IACd,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,8BAA8B,EAAA;IAVlC;MAYM,mBChMoB,EAAA;IDoL1B;MAeM,qBAAqB;MACrB,eAAe,EAAA;IAhBrB;MAmBM,eAAe;MACf,sBAAsB;MACtB,qBAAqB,EAAA;;AAK3B;EACE,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,mCAAmC;EACnC,kBAAkB,EAAA;EALpB;IAOI,mBCzMW;ID0MX,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,iBAAiB,EAAA;EAXrB;IAcI,eAAe,EAAA;;AAInB;EACE,+BAA+B;EAC/B,iBAAiB,EAAA;EAFnB;IAII,cC5Kc,EAAA;EDwKlB;IAOI,gBAAgB,EAAA;EAPpB;IAUI,yBAAyB;IACzB,cC3OsB;ID4OtB,eAAe;IACf,oBAAoB,EAAA;EAbxB;IAgBI,cChPsB;IDiPtB,eAAe;IACf,gBAAgB;IAChB,gBAAgB,EAAA;IAnBpB;MAqBM,0BAA0B,EAAA;;AAKhC;EAEI,cC5PsB,EAAA;;AD0P1B;EAKI,yBCvPiB;EDwPjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,UAAU,EAAA;EATd;IAWM,eAAe;IACf,UAAU;IACV,mBAAmB;IACnB,cChQe;IDiQf,UAAU;IACV,WAAW;IACX,YAAY,EAAA;IAjBlB;MAmBQ,mBCrQa;MDsQb,cAAc,EAAA;EApBtB;IAwBM,sBC1Qe,EAAA;;ADkPrB;EA4BI,yBAAyB,EAAA;EA5B7B;IA8BM,qBAAqB,EAAA;;AA9B3B;EAkCI,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,WAAW,EAAA;EArCf;IAuCM,sBAAsB;IACtB,YAAY;IACZ,iBAAiB,EAAA;EAzCvB;IA4CM,aAAa;IACb,qBAAqB,EAAA;EA7C3B;IAgDM,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,yBClSS;IDmST,cCnSS;IDoST,sBAAsB;IACtB,6BAA6B,EAAA;IAvDnC;MAyDQ,cAAc,EAAA;IAzDtB;MA4DQ,qBCzSiB;MD0SjB,yBC1SiB;MD2SjB,cAAc,EAAA;IA9DtB;MAiEQ,aAAa;MACb,gBAAgB,EAAA;;AAlExB;EAuEI,mBCrUgB;EDsUhB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,cC3TkB;ED4TlB,gBAAgB;EAChB,kBAAkB,EAAA;EA7EtB;IA+EM,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,yBAAyB,EAAA;;AAlF/B;EAsFI,8BClVuB,EAAA;;AD4P3B;EAyFI,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,cChVY;EDiVZ,2BC3VgB;ED4VhB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,iBAAiB;EACjB,kBAAkB,EAAA;EApGtB;IAsGM,eAAe;IACf,2BAA2B;IAC3B,aAAa;IACb,iBAAiB,EAAA;IAzGvB;MA2GQ,YAAY;MACZ,yBAAyB;MACzB,kBAAkB;MAClB,gBAAgB;MAChB,eAAe,EAAA;EA/GvB;IAoHQ,YAAY,EAAA;IApHpB;MAsHU,cCzTY,EAAA;EDmMtB;IA0HQ,uDAAoD,EAAA;IA1H5D;MA4HU,kBAAkB;MAClB,kBAAkB;MAClB,WAAW;MACX,YAAY,EAAA;EA/HtB;IAoIM,sBAAsB;IACtB,aAAa;IACb,iBAAiB,EAAA;IAtIvB;MAwIQ,YAAY;MACZ,mBAAmB;MACnB,mBAAmB;MACnB,cC7Xa;MD8Xb,YAAY;MACZ,gBAAgB;MAChB,gBAAgB;MAChB,iBAAiB;MACjB,aAAa;MACb,UAAU;MACV,YAAY;MACZ,kBAAkB;MAClB,iBAAiB,EAAA;MApJzB;QAsJU,mBCxYW;QDyYX,cAAc,EAAA;MAvJxB;QA0JU,mBCxZU;QDyZV,cCrZgB,EAAA;MD0P1B;QA8JU,kBAAkB;QAClB,kBAAkB,EAAA;QA/J5B;UAiKY,kBAAkB;UAClB,iBAAiB;UACjB,UAAU;UACV,QAAQ,EAAA;UApKpB;YAsKc,SAAS,EAAA;MAtKvB;QA2KU,UAAU,EAAA;IA3KpB;MA+KQ,uDAAoD,EAAA;MA/K5D;QAiLU,cC3agB,EAAA;ED0P1B;IAsLM,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB,EAAA;IA1LvB;MA4LQ,YAAY;MACZ,WAAW,EAAA;IA7LnB;MAgMQ,cC1bkB;MD2blB,gBAAgB;MAChB,WAAW,EAAA;MAlMnB;QAoMU,UAAU;QACV,eAAe,EAAA;QArMzB;UAuMY,eAAe,EAAA;MAvM3B;QA2MU,cC9YY,EAAA;QDmMtB;UA6MY,qBAAqB,EAAA;MA7MjC;QAiNU,iBAAiB,EAAA;MAjN3B;QAoNU,kBAAkB,EAAA;EApN5B;IAyNM,mBCrdqB;IDsdrB,YAAY;IACZ,aAAa,EAAA;EA3NnB;IA+NQ,yBAAyB;IACzB,cCpdQ;IDqdR,eAAe;IACf,eAAe;IACf,gBAAgB,EAAA;EAnOxB;IAuOQ,iBAAiB;IACjB,cC5dQ;ID6dR,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,uBAAuB;IACvB,qBAAqB;IACrB,sBAAA;IACA,4BAA4B;IAC5B,qBAAA;IACA,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,gBAAgB,EAAA;IApPxB;MAsPU,qBAAqB,EAAA;EAtP/B;IA8PM,gBAAgB;IAChB,iBAAiB;IACjB,cCpfU;IDqfV,gBAAgB,EAAA;IAjQtB;MA4PQ,aAAa,EAAA;IA5PrB;MAoQU,cC9fgB;MD+fhB,eAAe;MACf,iBAAiB;MACjB,gBAAgB,EAAA;IAvQ1B;MA0QU,qBAAqB,EAAA;IA1Q/B;MA6QU,YAAS;MACT,kBAAkB;MAClB,iBAAiB,EAAA;EA/Q3B;IAqRM,cCzgBU;ID0gBV,cAAc;IACd,oBAAoB,EAAA;IAvR1B;MAyRQ,eAAe;MACf,YAAY,EAAA;IA1RpB;MA6RQ,gBAAgB;MAChB,iBAAiB;MACjB,cCzhBkB;MD0hBlB,iBAAiB,EAAA;MAhSzB;QAkSU,gBAAgB,EAAA;MAlS1B;QAqSU,yBAAyB;QACzB,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;QACd,eAAe,EAAA;MAzSzB;QA4SU,mBAAmB,EAAA;;AA5S7B;EAkTI,yBChiBW,EAAA;ED8Of;IAoTM,yBC9iBoB;ID+iBpB,qBC/iBoB,EAAA;ID0P1B;MAuTQ,yBCjjBkB;MDkjBlB,qBCljBkB;MDmjBlB,mBAAmB,EAAA;EAzT3B;IA6TM,yBC1iBmB;ID2iBnB,qBC3iBmB,EAAA;ED6OzB;IAiUM,YAAY;IACZ,cAAc;IACd,mBAAmB,EAAA;;AAKzB;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB,EAAA;;AAGnB;EACE,SAAO,EAAA;;AAIT;EACE,cAAc;EACd,mBCrkBoB;EDskBpB,cAAc;EACd,eAAe,EAAA;EAJjB;IAMI,gBAAgB,EAAA;IANpB;MAQM,gBAAgB;MAChB,eAAe,EAAA;MATrB;QAWQ,gBAAgB,EAAA;IAXxB;MAeM,eAAe;MACf,0BAA0B,EAAA;EAhBhC;IAoBI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,iBAAiB,EAAA;IAxBrB;MA0BM,cAAc,EAAA;;AAKpB;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB,EAAA;EAH3B;IAMM,gBAAgB,EAAA;EANtB;IAUI,SAAS,EAAA;EAVb;IAaI,cCjnBiB;IDknBjB,gBAAgB;IAChB,eAAe,EAAA;EAfnB;IAqBI,iBAAiB,EAAA;IArBrB;MAmBM,kBAAkB,EAAA;IAnBxB;MAuBM,aAAa,EAAA;EAvBnB;IA2BI,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,cAAc;IACd,eAAe,EAAA;;AAKnB;EAGM,mBAAmB,EAAA;;AAHzB;EAMM,kBAAkB;EAClB,WAAW;EACX,SAAS,EAAA;;AARf;EAYI,gBAAgB,EAAA;EAZpB;IAcM,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,8BAA8B,EAAA;IAjBpC;MAoBU,cC5pBW,EAAA;EDwoBrB;IA2BM,gBAAgB;IAChB,YAAY,EAAA;IA5BlB;MA8BQ,YAAY;MACZ,aAAa;MACb,gBAAgB,EAAA;EAhCxB;IAmCM,cCprBe,EAAA;EDipBrB;IAsCM,kBAAkB,EAAA;;AAKxB;EACE,iBAAiB;EACjB,iBAAiB,EAAA;EAFnB;IAII,mBAAmB,EAAA;EAJvB;IAOI,iBAAiB,EAAA;;AAKrB;EAGM,kBAAkB;EAClB,WAAW;EACX,SAAS,EAAA;;AALf;EASI,gBAAgB;EAChB,gBAAgB;EAChB,cC1pBc,EAAA;;AD+oBlB;EAcI,kBAAkB,EAAA;;AAdtB;EAiBI,cChtBiB;EDitBjB,gBAAgB;EAChB,eAAe,EAAA;;AAnBnB;EAsBI,cAAc;EACd,gBAAgB,EAAA;;AAvBpB;EA2BM,gBAAgB,EAAA;;AA3BtB;EA+BI,gBAAgB,EAAA;;AAIpB;EACE,WAAW,EAAA;;AAEb;EACE,WAAW,EAAA;;AAEb;EAGM,cC7uBU;ED8uBV,cAAc;EACd,oBAAoB,EAAA;EAL1B;IAOQ,YAAY;IACZ,YAAY,EAAA;EARpB;IAWQ,gBAAgB;IAChB,iBAAiB;IACjB,cC7vBkB;ID8vBlB,iBAAiB;IACjB,sBAAsB,EAAA;IAf9B;MAiBU,cC3vBM;MD4vBN,gBAAgB,EAAA;IAlB1B;MAqBU,mBAAmB,EAAA;;AArB7B;EA0BM,iBAAiB;EACjB,cC3wBoB,EAAA;EDgvB1B;IA6BQ,SAAS,EAAA;;AAMjB;EAGM,kBAAkB;EAClB,WAAW;EACX,SAAS,EAAA;;AAMf;EAEI,cCzuBkB;ED0uBlB,gBAAgB,EAAA;;AAHpB;EAMI,cCpyBsB,EAAA;ED8xB1B;IAQM,gBAAgB,EAAA;EARtB;IAWM,gBAAgB,EAAA;;AAXtB;EAeI,cAAc;EACd,cAAc,EAAA;EAhBlB;IAkBM,gBAAgB;IAChB,eAAe,EAAA;;AAnBrB;EAwBM,qBAAqB,EAAA;;AAxB3B;EA4BI,mCAAmC;EACnC,cAAc;EACd,kBAAkB,EAAA;EA9BtB;IAgCM,UAAU;IACV,aAAa;IACb,kCAAkC,EAAA;IAlCxC;MAoCQ,2BAA2B;MAC3B,sBAAsB,EAAA;IArC9B;MAwCQ,aAAa,EAAA;MAxCrB;QA0CU,yBAAyB,EAAA;MA1CnC;QA6CU,eAAe;QACf,gBAAgB,EAAA;MA9C1B;QAiDU,eAAe,EAAA;MAjDzB;QAoDU,eAAe;QACf,gBAAgB,EAAA;QArD1B;UAuDY,qBAAqB,EAAA;IAvDjC;MA4DQ,aAAa,EAAA;MA5DrB;QA8DU,yBCh1BK;QDi1BL,qBCj1BK;QDk1BL,sBAAsB;QACtB,YAAY;QACZ,kBAAkB;QAClB,UAAU,EAAA;QAnEpB;UAqEY,qBCn2Bc;UDo2Bd,yBCp2Bc,EAAA;UD8xB1B;YAwEc,mBAAmB,EAAA;YAxEjC;cA0EgB,WAAW,EAAA;UA1E3B;YA8Ec,qBC52BY;YD62BZ,yBC72BY,EAAA;QD8xB1B;UAmFY,eAAe;UACf,cAAc;UACd,cAAc;UACd,qBAAqB;UACrB,gBAAgB;UAChB,oBAAoB,EAAA;UAxFhC;YA0Fc,qBAAqB,EAAA;QA1FnC;UA8FY,qBC/2Ba;UDg3Bb,yBCh3Ba,EAAA;;ADy3BzB;EAEI,yBC33BqB;ED43BrB,qBC53BqB,EAAA;;ADy3BzB;EAMI,wBAAwB;EACxB,2BAA2B,EAAA;;AAG/B;EACE,yBCz4BmB;ED04BnB,cAAc;EACd,yBC34BmB;ED44BnB,kBAAkB;EAClB,eCh4BW;EDi4BX,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB,EAAA;EARrB;IAUI,YAAY;IACZ,yBAAyB;IACzB,yBCr2BkB;IDs2BlB,cCt2BkB;IDu2BlB,gBAAgB,EAAA;IAdpB;MAgBM,yBCz2BgB;MD02BhB,yBAAyB;MACzB,mBAAmB,EAAA;EAlBzB;IAsBI,yBAAyB;IACzB,cC/5BiB,EAAA;EDw4BrB;IA0BI,yBCj6B2B;IDk6B3B,qBCl6B2B;IDm6B3B,eAAe,EAAA;EA5BnB;IA+BI,aAAa,EAAA;EA/BjB;IAkCI,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,uBAAuB,EAAA;;AAI3B;EACE,cCp4BoB,EAAA;;ADu4BtB;EACE,gBAAgB;EAChB,cCz4BoB,EAAA;;AD44BtB;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cCj5BoB,EAAA;;ADq5BtB;EACE;IACE,kCAAkC,EAAA;EAEpC;IACE,kCAAkC,EAAA,EACnC;;AAGH;EACE;IAEI,eAAe,EAAA;EAFnB;IAKI,eAAe,EAAA;EAGnB;IACE,kCAAkC,EAAA;IADpC;MAIM,eAAe,EAAA;IAJrB;MAOM,eAAe,EAAA;IAPrB;MAWI,QAAQ,EAAA;EAGZ;IACE,kCAAkC,EAAA,EACnC;;AAIH;EAEE;IACE,qBAAqB,EAAA;IADvB;MAGI,cAAc;MACd,kBAAkB;MAClB,gBAAgB,EAAA;MALpB;QAOM,UAAU;QACV,WAAW;QACX,mBAAmB,EAAA;QATzB;UAWQ,gBAAgB,EAAA;MAXxB;QAeM,WAAW;QACX,WAAW;QACX,gBAAgB,EAAA;QAjBtB;UAoBU,eAAe,EAAA;QApBzB;UAuBU,eAAe,EAAA;MAvBzB;QA4BM,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,aAAa;QACb,2BAA2B,EAAA;QAhCjC;UAkCQ,SAAS,EAAA;EAKjB;IACE,gBAAgB,EAAA;IADlB;MAGI,iBAAiB;MACjB,wBAAwB;MACxB,gBAAgB,EAAA;EAIpB;IACE,UAAU;IACV,YAAY;IACZ,cAAc,EAAA;EAEhB;IACE,iBAAiB;IACjB,UAAU;IACV,cAAc,EAAA;IAHhB;MAKI,eAAe,EAAA;EAInB;IAGM,gBAAgB,EAAA;EAHtB;IAOI,gBAAgB,EAAA;IAPpB;MASM,iBAAiB,EAAA;MATvB;QAWQ,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;QACd,gBAAgB,EAAA;IAfxB;MAmBM,kBAAkB,EAAA;MAnBxB;QAsBU,iBAAiB,EAAA;MAtB3B;QAyBU,WAAW;QACX,YAAY;QACZ,eAAe,EAAA;MA3BzB;QAgCU,eAAe,EAAA;MAhCzB;QAmCU,eAAe,EAAA;IAnCzB;MAwCM,cAAc,EAAA;MAxCpB;QA0CQ,kBAAkB,EAAA;MA1C1B;QA6CQ,gBAAgB,EAAA;IA7CxB;MAiDM,gBAAgB;MAChB,iBAAiB,EAAA;IAlDvB;MAqDM,kBAAkB,EAAA;MArDxB;QAwDU,eAAe;QACf,iBAAiB;QACjB,gBAAgB,EAAA;MA1D1B;QA6DU,mBAAmB,EAAA;EA7D7B;IAmEI,4BAA4B;IAC5B,YAAY;IACZ,kBAAkB,EAAA;IArEtB;MAuEM,YAAY,EAAA;IAvElB;MA0EM,cAAc;MACd,WAAW;MACX,kBAAkB;MAClB,cAAc,EAAA;EAMpB;IAEE,eAAe,EAAA;EAFjB;IAKE,eAAe;IACf,0BAA0B,EAAA;EAN5B;IASE,eAAe,EAAA;EAKjB;IAEI,gBAAgB,EAAA;EAFpB;IASM,8BAA8B,EAAA;IATpC;MAOQ,aAAa,EAAA;IAPrB;MAYU,YAAY;MACZ,mBAAmB,EAAA,EACpB;;AAOX;EAEI,UAAU;EACV,mBAAmB,EAAA;;AAIvB,aAAA;AACA;EACE,aAAa,EAAA;;AAEf;EACE,qCAAqC;EACrC,cAAc,EAAA;;AAEhB;EACE,sCAAsC,EAAA;;AAGxC;EACE,0CAA0C,EAAA;;AAE5C;EACE,0CAA0C;EAC1C,6BAA6B,EAAA;;AAE/B;EACE,2BAA2B,EAAA;;AAI7B;;EAEE,wBAAwB,EAAA;;AAE1B;EACE,YAAY,EAAA;;AAEd;EACE,aAAa,EAAA;;AAEf;;EAEE,cAAc,EAAA;;AAGhB;EACE,cCztCyB;ED0tCzB,eCjsCY;EDksCZ,8BC3tCyB;ED4tCzB,aAAa;EACb,WAAW;EACX,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,mCAAmC;EACnC,YAAY,EAAA;EAZd;IAcI,gBAAgB;IAChB,eC/sCQ,EAAA;EDgsCZ;IAkBI,yBC1uCuB,EAAA;EDwtC3B;IAqBI,aAAa,EAAA;EArBjB;IAwBI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,eAAe,EAAA;IA3BnB;MA6BM,yBCvuCS;MDwuCT,iBAAiB;MACjB,cCzuCS,EAAA;MD0sCf;QAiCQ,qBC1uCiB;QD2uCjB,yBC3uCiB;QD4uCjB,cAAc,EAAA;IAnCtB;MAuCM,cAAc,EAAA;EAvCpB;IA2CI,UAAU;IACV,eAAe;IACf,cC5sCkB,EAAA;ID+pCtB;MA+CM,eAAe;MACf,qBAAqB,EAAA;IAhD3B;MAmDM,kBAAkB,EAAA;;AAIxB;EACE,mBAAmB;EACnB,WAAW;EACX,WAAW,EAAA;EAHb;IAKI,cC1wCiB;ID2wCjB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,8BChxCiB;IDixCjB,UAAU;IACV,YAAY;IACZ,cAAc;IACd,cAAc,EAAA;EAflB;IAkBI,WAAW,EAAA;IAlBf;MAoBM,kBAAkB,EAAA;IApBxB;MAuBM,qBAAqB,EAAA;EAvB3B;IA2BI,aAAa;IACb,kCAAkC;IAClC,yBClyCiB;IDmyCjB,kBAAkB;IAClB,WAAW;IACX,cCryCiB,EAAA;IDqwCrB;MAkCM,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB,EAAA;EApCvB;IAwCI,cCvzCuB,EAAA;ID+wC3B;MA0CM,yBC/yCe;MDgzCf,cChzCe;MDizCf,mBAAmB;MACnB,iBAAiB;MACjB,kBAAkB;MAClB,WAAW,EAAA;MA/CjB;QAiDQ,yBCtzCa;QDuzCb,cAAc,EAAA;EAlDtB;IAuDI,yBC5zCiB;ID6zCjB,cAAc,EAAA;;AAIlB;EACE,gBAAgB,EAAA;EADlB;IAGI,WAAW;IACX,yBAAoC;IACpC,kBAAkB;IAClB,cC/0CsB,EAAA;EDy0C1B;IASI,cC1xCc,EAAA;EDixClB;IAYI,cC9xCkB,EAAA;EDkxCtB;IAeI,kBAAkB,EAAA;EAftB;IAkBI,iBAAiB,EAAA;EAlBrB;IAqBI,cAAc;IACd,yBCn1CW;IDo1CX,YAAY;IACZ,yBCr1CW,EAAA;ID6zCf;MA0BM,yBCv2Cc;MDw2Cd,yBCx2Cc,EAAA;MD60CpB;QA6BQ,kBAAkB,EAAA;IA7B1B;MAiCM,aAAa,EAAA;IAjCnB;MAoCM,cCj2CS;MDk2CT,mBAAmB;MACnB,yBCn2CS,EAAA;ED6zCf;IA0CI,YAAY,EAAA;EA1ChB;IA6CI,cCx3CuB;IDy3CvB,mBAAmB;IACnB,cAAc;IACd,gBAAgB,EAAA;;AAIpB;EACE;IACE,aAAa,EAAA;EAEf;IACE,cAAc;IACd,gBAAgB,EAAA;EAElB;IACE,WAAW,EAAA;EAEb;IACE,kBAAkB;IAClB,cAAc,EAAA;IAFhB;MAII,eAAe,EAAA;EAGnB;IACE,iBAAiB,EAAA;IADnB;MAGI,eAAe,EAAA,EAChB;;AAIL;EACE;IACE,YAAY;IACZ,eAAe,EAAA;EAEjB;IACE,YAAY,EAAA,EACb","sourcesContent":["@import '../../../app/variables.scss';\nbody {\n  overflow-y: scroll !important;\n}\n.psuedo-link {\n  cursor: pointer;\n}\n\n.helper-text-wrapper {\n  display: grid;\n}\n\n.helper-text-mobile {\n  position: relative;\n  top: 16%;\n  left: 8%;\n  pointer-events: none;\n}\n\n.helper-text-button, .helper-text-mobile {\n  grid-area: 1/1;\n}\n\ni.fa.fa-question {\n  color: $evanta-blue;\n  font-size: 13px;\n  position: absolute;\n  pointer-events: fill;\n  &.question-larger {\n    font-size: 20px;\n  }\n}\n\n@media screen and (min-device-width: 992px) {\n  .logoImageWide {\n    display: block;\n  }\n  .logoImageStacked {\n    display: none;\n  }\n}\n\n@media screen and (max-device-width: 991px) and (min-device-width: 768px) {\n  .logoImageWide {\n    display: none;\n  }\n  .logoImageStacked {\n    display: block;\n  }\n}\n\n@media screen and (max-device-width: 767px) {\n  .logoImageWide {\n    display: block;\n  }\n  .logoImageStacked {\n    display: none;\n  }\n}\n\n// header\n.virtual-portal-header {\n  display: flex;\n  flex: 1;\n  width: 100%;\n  background-color: #002856;\n  min-height: 100px;\n  align-items: start;\n  box-shadow: 1px 5px 8px 0px #9c9898;\n  .container {\n    white-space: pre-wrap;\n    grid-template-columns: 30% 50% 20%;\n    grid-gap: 7px;\n    display: grid;\n    cursor: default;\n    color: #ffffff;\n    padding-top: 25px;\n    position: relative;\n    .logo img {\n      margin: 10px 0 0;\n      width: 179px;\n      max-width: 179px;\n      height: auto;\n    }\n    .title {\n      .centered {\n        margin: 0 0 0 0;\n        h4 {\n          font-size: 24px;\n        }\n        h5 {\n          font-weight: 100;\n          font-size: 18px;\n          margin-top: -5px;\n        }\n      }\n    }\n    .info {\n      display: inline-block;\n      position: relative;\n      a {\n        float: right;\n        background-color: #ffffff;\n        padding: 1px 10px;\n        border-radius: 50%;\n        color: $evanta-blue;\n        font-weight: 900;\n        margin-right: 15px;\n        &:hover {\n          text-decoration: none;\n        }\n      }\n      .user-profile-image{\n        max-height: 27px;\n        max-width: 27px;\n        &:hover {\n          cursor: pointer;\n        }\n      }\n      .menu {\n        width: 236px;\n        position: absolute;\n        top: 75px;\n        right: 0;\n        background: #ffffff;\n        color: $eblack;\n        z-index: 999;\n        padding: 26px;\n        box-shadow: 2px 5px 7px 0px #bfbdbd;\n        .menu-subheader {\n          color: $medium-gray;\n          font-size: 14px;\n          line-height: 22px;\n          letter-spacing: .88px;\n          font-weight: 400;\n        }\n        .menu-name {\n          white-space: pre-wrap;\n          overflow-wrap: break-word;\n        }\n        .menu-title {\n          white-space: pre;\n          margin-bottom: 0;\n        }\n        .menu-title {\n          color: $medium-light-gray;\n          font-size: 12px;\n          line-height: 22px;\n          letter-spacing: .88px;\n          text-transform: uppercase;\n        }\n        hr {\n          margin: 2rem 0;\n        }\n        ul, .menu-item {\n          list-style-type: none;\n          list-style-position:inside;\n          margin:0.5rem 0;\n          letter-spacing: .88px;\n          padding:0;\n          font-size: 14px;\n          a {\n            font-weight: 400;\n            margin:0;\n            float: none;\n            padding:0;\n            color: $medium-dark-gray;\n          }\n        }\n        .menu-item, a:hover{\n          font-weight: 600;\n          cursor: pointer;\n          color: $evanta-blue;\n        }\n      }\n    }\n  }\n}\n\n// welcome section\n.welcome {\n  margin: 5px 0 30px;\n  h2 {\n    color: $eblack;\n    font-size: 40px;\n  }\n  h5 {\n    color: $medium-dark-gray;\n    text-transform: uppercase;\n    letter-spacing: .88px;\n    font-size: 14px;\n  }\n}\n// alert section\n.alert-section {\n  height: auto;\n  .header-alert {\n    background: $solar;\n    color: #ffffff;\n    width: auto;\n    display: inline-block;\n    padding: 10px 15px;\n    margin-right: 10px;\n    font-size: 1rem;\n    border-radius: 0px 0px 3px 3px;\n    &.gray {\n      background: $medium-dark-gray;\n    }\n    &:hover {\n      text-decoration: none;\n      cursor: pointer;\n    }\n    .fa {\n      font-size: 36px;\n      vertical-align: middle;\n      padding: 0 0 1px 10px;\n    }\n  }\n}\n// emergency broadcast message section\n.emergency-broadcast-section {\n  height: auto;\n  width: 100%;\n  max-width: none !important;\n  box-shadow: 1px 5px 8px 0px #9c9898;\n  margin-bottom: 5px;\n  .header-emergency-broadcast {\n    background: $solar;\n    color: #ffffff;\n    width: 100%;\n    padding: 10px 15px;\n    font-size: 1.2rem;\n  }\n  .body-emergency-broadcast {\n    font-size: 1rem;\n  }\n}\n\n.no-agenda {\n  min-height: calc(100vh - 225px);\n  padding-top: 50px;\n  h1, h4 {\n    color: $vp-black;\n  }\n  h4 {\n    font-weight: 600;\n  }\n  h5 {\n    text-transform: uppercase;\n    color: $medium-dark-gray;\n    font-size: 14px;\n    letter-spacing: .8px;\n  }\n  p {\n    color: $medium-dark-gray;\n    font-size: 18px;\n    margin-top: 20px;\n    font-weight: 100;\n    a {\n      text-decoration: underline;\n    }\n  }\n}\n// session index\n.virtual-sessions-page {\n  .session-advisory {\n    color: $medium-dark-gray;\n  }\n  button.filter-tabs {\n    border: 2px solid $evanta-blue;\n    min-width: 250px;\n    cursor: pointer;\n    border-radius: 3px;\n    padding: 0;\n    .my-schedule, .agenda {\n      font-size: 1rem;\n      width: 50%;\n      background: #ffffff;\n      color: $evanta-blue;\n      width: 50%;\n      float: left;\n      padding: 4px;\n      &.active {\n        background: $evanta-blue;\n        color: #ffffff;\n      }\n    }\n    &:focus {\n      outline-color: $evanta-blue;\n    }\n  }\n  .session-link {\n    width: calc(100% - 100px);\n    &:hover{\n      text-decoration: none;\n    }\n  }\n  .session-icons {\n    position: inherit;\n    display: grid;\n    max-height: 184px;\n    right: 10px;\n    button {\n      vertical-align: middle;\n      margin: auto;\n      margin-right: 0px;\n    }\n    .editp2plink{\n      display: grid;\n      text-decoration: none;\n    }\n    .editp2p{\n      border-radius: 5px;\n      font-size: 14px;\n      line-height: 1rem;\n      padding: 10px 3px;\n      border: 2px solid $solar;\n      color: $solar;\n      vertical-align: middle;\n      background-color: transparent;\n      &.btn-danger {\n        color: #ffffff;\n      }\n      &:hover{\n        border-color: $solar-secondary;\n        background-color: $solar-secondary;\n        color: #ffffff;\n      }\n      &:focus {\n        outline: none;\n        box-shadow: none;\n      }\n    }\n  }\n  .time-block-section {\n    background: $light-gray;\n    margin: 30px 0;\n    padding: 10px;\n    font-size: .8rem;\n    color: $gartner-blue;\n    font-weight: 600;\n    border-radius: 3px;\n    p.formatted-time {\n      margin: 20px 0;\n      font-weight: 700;\n      font-size: 14px;\n      text-transform: uppercase;\n    }\n  }\n  .day-break {\n    border-top: 2px dashed $medium-light-gray;\n  }\n  .session {\n    grid-template-columns: 17% 68% 15%;\n    display: grid;\n    background: #ffffff;\n    color: $eblack;\n    border: 0.5px solid $light-gray;\n    line-height: 10px;\n    text-decoration: none;\n    position: relative;\n    box-shadow: 2px 2px 7px 0px #bfbdbd;\n    margin: 20px 0;\n    min-height: 200px;\n    border-radius: 3px;\n    &.itinerary {\n      padding: 0 15px;\n      grid-template-columns: 100%;\n      min-height: 0;\n      text-indent: 20px;\n      p {\n        margin: 10px;\n        text-transform: uppercase;\n        font-style: italic;\n        font-weight: 400;\n        font-size: 14px;\n      }\n    }\n    &.session-over {\n      .container {\n        opacity: 0.6;\n        p, h3 {\n          color: $vp-dark-gray;\n        }\n      }\n      .session-cta-wrapper {\n        box-shadow: inset 0 0 0 100vw rgba(239,239,240,0.78);\n        .registration-button {\n          font-size: 1.25rem;\n          border-radius: 50%;\n          width: 55px;\n          height: 55px;\n        }\n      }\n    }\n    .session-cta-wrapper {\n      background-size: cover;\n      display: flex;\n      max-height: 198px;\n      .registration-button {\n        margin: auto;\n        background: #ffffff;\n        border-radius: 35px;\n        color: $evanta-blue;\n        border: none;\n        font-weight: 600;\n        text-align: left;\n        font-size: .88rem;\n        padding: 10px;\n        width: 75%;\n        height: 60px;\n        text-align: center;\n        line-height: 15px;\n        &.registered {\n          background: $evanta-blue;\n          color: #ffffff;\n        }\n        &.p2pSession {\n          background: $light-gray;\n          color: $medium-dark-gray;\n        }\n        .icon-and-text {\n          position: relative;\n          padding-left: 30px;\n          i {\n            position: absolute;\n            font-size: 1.5rem;\n            left: 10px;\n            top: 3px;\n            &.fa-minus {\n              top: -4px;\n            }\n          }\n        }\n        &:focus{\n          outline: 0;\n        }\n      }\n      &.not-authorized {\n        box-shadow: inset 0 0 0 100vw rgba(239,239,240,0.75);\n        .registration-button {\n          color: $medium-dark-gray;\n        }\n      }\n    }\n    .container {\n      display: flex;\n      flex-wrap: wrap;\n      flex-direction: column;\n      padding: 15px 35px;\n      margin-top: -10px;\n      .inner-wrapper {\n        margin: auto;\n        width: 100%;\n      }\n      .action-links {\n        color: $medium-dark-gray;\n        margin-top: 10px;\n        width: 100%;\n        .more, .add-to-calendar {\n          width: 50%;\n          font-size: 14px;\n          &:hover {\n            cursor: pointer;\n          }\n        }\n        .add-to-calendar, .more {\n          color: $vp-dark-gray;\n          &:hover {\n            text-decoration: none;\n          }\n        }\n        .add-to-calendar {\n          margin-left: 45px;\n        }\n        .fa {\n          margin-right: 10px;\n        }\n      }\n    }\n    .session-time {\n      background: $medium-light-gray;\n      color: white;\n      padding: 10px;\n    }\n    .session-header {\n      .session-type {\n        text-transform: uppercase;\n        color: $eblack;\n        margin: 8px 0px;\n        font-size: 14px;\n        font-weight: 600;\n      }\n       // MK ~ please don't remove commented out autoprefixers below 08/18/2020\n      .session-name {\n        padding-top: 10px;\n        color: $eblack;\n        display: block;\n        display: -webkit-box;\n        max-width: 100%;\n        margin: -15px auto 10px;\n        -webkit-line-clamp: 2;\n        /* autoprefixer: off */\n        -webkit-box-orient: vertical;\n        /* autoprefixer: on */\n        overflow: hidden;\n        text-overflow: ellipsis;\n        font-size: 26px;\n        font-weight: 600;\n        &.open-true {\n          -webkit-line-clamp: 3;\n        }\n      }\n    }\n    .session-information {\n      &.hidden{\n        display: none;\n      }\n      max-width: 900px;\n      padding-top: 10px;\n      color: $eblack;\n      line-height: 1em;\n      .session-body {\n        p, li {\n          color: $medium-dark-gray;\n          font-size: 17px;\n          line-height: 20px;\n          font-weight: 400;\n        }\n        ul {\n          list-style-type: none;\n        }\n        ul > li:before {\n          content: '–';\n          position: absolute;\n          margin-left: -1em;\n        }\n      }\n    }\n\n    .user-list.speaker {\n      color: $eblack;\n      margin: 10px 0;\n      text-transform: none;\n      img {\n        max-width: 65px;\n        height: auto;\n      }\n      .user-info {\n        font-weight: 100;\n        font-size: 1.2rem;\n        color: $medium-dark-gray;\n        line-height: 15px;\n        .full-name {\n          font-weight: 600;\n        }\n        .speaker-type {\n          text-transform: uppercase;\n          font-size: .75rem;\n          font-weight: 400;\n          color: #000000;\n          margin-top: 9px;\n        }\n        div {\n          margin: 0px 0px 5px;\n        }\n      }\n    }\n  }\n  .btn.btn-danger {\n    background-color: $solar;\n    &:disabled, &.disabled {\n      background-color: $medium-dark-gray;\n      border-color: $medium-dark-gray;\n      &:hover {\n        background-color: $medium-dark-gray;\n        border-color: $medium-dark-gray;\n        cursor: not-allowed;\n      }\n    }\n    &:hover{\n      background-color: $solar-secondary;\n      border-color: $solar-secondary;\n    }\n    &.closing-details {\n      margin: auto;\n      display: block;\n      margin-bottom: 50px;\n    }\n  }\n}\n\n.header-router-footer {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.header-router {\n  flex: 1;\n}\n\n// footer\nfooter.virtual-footer {\n  flex-shrink: 0;\n  background: $gartner-blue;\n  color: #ffffff;\n  padding: 15px 0;\n  .session-closing-details {\n    margin-top: 25px;\n    p {\n      font-weight: 100;\n      font-size: 26px;\n      strong {\n        font-weight: 600;\n      }\n    }\n    .pseudo-link {\n      cursor: pointer;\n      text-decoration: underline;\n    }\n  }\n  .copyright {\n    display: block;\n    text-align: center;\n    font-size: 14px;\n    font-style: italic;\n    margin: 25px auto;\n    a {\n      color: #ffffff;\n    }\n  }\n}\n\n.react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal {\n  padding: 45px;\n  min-height: 500px;\n  background-color: #ffffff;\n  .button-container {\n    button {\n      margin-top: 40px;\n    }\n  }\n  .pm-info > p {\n    margin: 0;\n  }\n  .live-chat-link{\n    color: $evanta-blue;\n    font-weight: 600;\n    cursor: pointer;\n  }\n  &.confirm{\n    .generic-info-modal-content p {\n      text-align: center;\n    }\n    min-height: 275px;\n    .button-container{\n      display: flex;\n    }\n  }\n  .modalCancelText {\n    text-align: center;\n    cursor: pointer;\n    text-decoration: underline;\n    color: #4330ff;\n    font-size: 24px;\n  }\n}\n\n// evaluation modal\n.react-modal.evaluation-modal {\n  .header {\n    h3 {\n      margin-bottom: 20px;\n    }\n    .fa-times-thin {\n      position: absolute;\n      right: 15px;\n      top: 10px;\n    }\n  }\n  .evaluation-modal-content {\n    margin-top: 2rem;\n    .evaluation-modal-stars {\n      text-align: center;\n      margin: 0 3.5rem 1rem;\n      display: flex;\n      justify-content: space-between;\n      .fa.fa-star-o {\n        &.unchecked {\n          color: $evanta-blue;\n        }\n      }\n    }\n    textarea.form-control {\n      // border: none;\n      // padding: 0;\n      min-height: 90px;\n      resize: none;\n      &:focus {\n        border: none;\n        outline: none;\n        box-shadow: none;\n      }\n    }::placeholder {\n      color: $medium-gray;\n    }\n    .button-container {\n      text-align: center;\n    }\n  }\n}\n\n.follow-up {\n  padding-top: 10px;\n  margin-right: 5px;\n  .follow-up-label {\n    padding-right: 20px;\n  }\n  input {\n    margin-right: 5px;\n  }\n}\n\n// generic modal\n.react-modal.generic.info-modal {\n  .generic-info-modal-header {\n    .fa-times-thin {\n      position: absolute;\n      right: 15px;\n      top: 10px;\n    }\n  }\n  h4 {\n    font-weight: 600;\n    margin:\t0 0 22px;\n    color: $vp-black;\n  }\n  .fa {\n    margin-right: 10px;\n  }\n  a {\n    color: $evanta-blue;\n    font-weight: 600;\n    cursor: pointer;\n  }\n  .eblue-button a {\n    color: #ffffff;\n    font-weight: 400;\n  }\n  .button-container {\n    hr {\n      margin-top: 45px;\n    }\n  }\n  .take-event-eval {\n    font-weight: 400;\n  }\n}\n\n.react-modal.info-pop-up {\n  height: 90%;\n}\n.react-modal.double-booking, .react-modal.troubleshooting {\n  height: 70%;\n}\n.react-modal.wishlist-user-info {\n  .generic-info-modal-content {\n    .user-list {\n      color: $eblack;\n      margin: 10px 0;\n      text-transform: none;\n      img {\n        width: 110px;\n        height: auto;\n      }\n      .user-info {\n        font-weight: 400;\n        font-size: 1.2rem;\n        color: $medium-dark-gray;\n        line-height: 20px;\n        padding: 20px 0 0 10px;\n        .full-name {\n          color: $eblack;\n          font-weight: 800;\n        }\n        div {\n          margin: 0px 0px 5px;\n        }\n      }\n    }\n    .bio {\n      padding-top: 20px;\n      color: $medium-dark-gray;\n      p {\n        margin: 0;\n      }\n    }\n  }\n}\n// generic error\n.react-modal.error-modal {\n  .generic-error-modal-header {\n    .fa-times-thin {\n      position: absolute;\n      right: 15px;\n      top: 10px;\n    }\n  }\n}\n\n// closing details modal\n.closing-details {\n  .see-you-soon {\n    color: $vp-dark-gray;\n    margin: 30px 0 0;\n  }\n  .thank-you-body-content {\n    color: $medium-dark-gray;\n    h6 {\n      font-weight: 600;\n    }\n    p {\n      font-weight: 300;\n    }\n  }\n  .take-event-eval {\n    display: block;\n    margin: 25px 0;\n    .fa {\n      font-weight: 600;\n      font-size: 18px;\n    }\n  }\n  button, a {\n    &:hover {\n      text-decoration: none;\n    }\n  }\n  .upcoming-event-row {\n    box-shadow: 2px 2px 7px 0px #bfbdbd;\n    margin: 15px 0;\n    border-radius: 3px;\n    .container {\n      padding: 0;\n      display: grid;\n      grid-template-columns: 20% 55% 25%;\n      .event-image {\n        background-position: center;\n        background-size: cover;\n      }\n      .main-content {\n        padding: 10px;\n        .event-date {\n          text-transform: uppercase;\n        }\n        h5 {\n          font-size: 14px;\n          font-weight: 600;\n        }\n        h6 {\n          font-size: 12px;\n        }\n        .learn-more {\n          font-size: 12px;\n          font-weight: 500;\n          &:hover{\n            text-decoration: none;\n          }\n        }\n      }\n      .register-button-container {\n        display: grid;\n        button.btn.btn-danger {\n          background-color: $solar;\n          border-color: $solar;\n          vertical-align: middle;\n          margin: auto;\n          margin-right: 10px;\n          padding: 0;\n          &.registered {\n            border-color: $medium-dark-gray;\n            background-color: $medium-dark-gray;\n            a {\n              cursor: not-allowed;\n              .fa {\n                margin: 1px;\n              }\n            }\n            &:hover {\n              border-color: $medium-dark-gray;\n              background-color: $medium-dark-gray;\n            }\n          }\n          a {\n            font-size: 11px;\n            color: #ffffff;\n            display: block;\n            padding: 6px 12px 6px;\n            font-weight: 400;\n            letter-spacing: .5px;\n            &:hover{\n              text-decoration: none;\n            }\n          }\n          &:hover {\n            border-color: $solar-secondary;\n            background-color: $solar-secondary;\n          }\n        }\n      }\n    }\n  }\n}\n\n// general css\n.btn-danger {\n  &:hover{\n    background-color: $solar-secondary;\n    border-color: $solar-secondary;\n  }\n  &:focus {\n    outline: none !important;\n    box-shadow: none !important;\n  }\n}\n.eblue-button {\n  background-color: $evanta-blue;\n  color: #ffffff;\n  border: 2px solid $evanta-blue;\n  border-radius: 5px;\n  font-size: $medium;\n  padding: 10px 15px;\n  letter-spacing: 1.5px;\n  white-space: nowrap;\n  &:disabled {\n    opacity: 0.6;\n    background-color: #ffffff;\n    border: 2px solid $vp-dark-gray;\n    color: $vp-dark-gray;\n    font-weight: 400;\n    &:hover {\n      border: 2px solid $vp-dark-gray;\n      background-color: inherit;\n      cursor: not-allowed;\n    }\n  }\n  &:active {\n    background-color: #ffffff;\n    color: $evanta-blue;\n  }\n  &:hover {\n    background-color: $evanta-blue-secondary;\n    border-color: $evanta-blue-secondary;\n    cursor: pointer;\n  }\n  &:focus {\n    outline: none;\n  }\n  &.open-chat-window {\n    margin: auto;\n    display: block;\n    padding: 4px 6px;\n    font-size: 1rem;\n    letter-spacing: inherit;\n  }\n}\n\n.center-progress-display i.fa-spinner {\n  color: $vp-dark-gray;\n}\n\n.fa-times-thin:before {\n  content: '\\00d7';\n  color: $vp-dark-gray;\n}\n\nhr {\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 400;\n  margin: 0 0 22px;\n  color: $vp-dark-gray;\n}\n\n\n@media only screen and (max-width : 1200px) {\n  .virtual-sessions-page .session {\n    grid-template-columns: 20% 60% 20%;\n  }\n  .virtual-sessions-page .session-timeslots {\n    grid-template-columns: 20% 60% 20%;\n  }\n}\n\n@media only screen and (max-width : 992px) {\n  .welcome {\n    h2 {\n      font-size: 42px;\n    }\n    h5 {\n      font-size: 12px;\n    }\n  }\n  .virtual-sessions-page .session {\n    grid-template-columns: 25% 50% 25%;\n    .session-header {\n      .session-name {\n        font-size: 24px;\n      }\n      .session-type {\n        font-size: 12px;\n      }\n    }\n    .session-icons {\n      right: 0;\n    }\n  }\n  .virtual-sessions-page .session-timeslots {\n    grid-template-columns: 25% 50% 25%;\n  }\n\n}\n\n@media only screen and (max-width : 767px) {\n  // header\n  .virtual-portal-header {\n    display: inline-block;\n    .container {\n      display: block;\n      position: relative;\n      padding-top: 5px;\n      .logo {\n        width: 50%;\n        float: left;\n        margin-bottom: 10px;\n        img {\n          max-width: 128px;\n        }\n      }\n      .title {\n        width: 100%;\n        float: left;\n        margin-left: 3px;\n        .centered {\n          h4 {\n            font-size: 22px;\n          }\n          h5 {\n            font-size: 14px;\n          }\n        }\n      }\n      .info {\n        position: absolute;\n        right: 10px;\n        top: 15px;\n        display: flex;\n        flex-direction: row-reverse;\n        .menu {\n          top: 93px;\n        }\n      }\n    }\n  }\n  .alert-section .header-alert{\n    font-size: .8rem;\n    .fa {\n      font-size: 1.5rem;\n      padding: 0px 0px 0px 5px;\n      line-height: 5px;\n    }\n  }\n  // filter tabs and welcome\n  .filter-tabs {\n    width: 95%;\n    margin: auto;\n    display: block;\n  }\n  .welcome {\n    margin: 20px auto;\n    width: 95%;\n    display: block;\n    h2 {\n      font-size: 32px;\n    }\n  }\n  // session row\n  .virtual-sessions-page {\n    .time-block-section {\n      p.formatted-time {\n        font-weight: 600;\n      }\n    }\n    .session {\n      display: inherit;\n      .session-cta-wrapper {\n        min-height: 115px;\n        .registration-button {\n          margin-left: 3%;\n          font-size: .75rem;\n          font-weight: 400;\n          max-width: 40%;\n          max-height: 50px;\n        }\n      }\n      .container {\n        padding: 15px 10px;\n        .action-links {\n          .add-to-calendar {\n            margin-left: none;\n          }\n          .add-to-calendar, .more {\n            float: left;\n            margin: auto;\n            font-size: 14px;\n          }\n        }\n        .session-header {\n          .session-name {\n            font-size: 20px;\n          }\n          .session-type {\n            font-size: 12px;\n          }\n        }\n      }\n      .session-icons {\n        margin: 10px 0;\n        button {\n          margin-right: auto;\n        }\n        .eblue-button {\n          font-size: .8rem;\n        }\n      }\n      &.itinerary p {\n        margin-left: 0px;\n        text-indent: 10px;\n      }\n      .session-information {\n        line-height: .75em;\n        .session-body {\n          p, li {\n            font-size: 14px;\n            line-height: 18px;\n            font-weight: 400;\n          }\n          ul > li:before {\n            margin-left: -.75em;\n          }\n        }\n      }\n    }\n    .session-timeslots{\n      grid-template-columns: unset;\n      height: auto;\n      text-align: center;\n      .timeslot-btn-div{\n        margin: 15px;\n      }\n      .add-to-calendar {\n        display: block;\n        width: 100%;\n        text-align: center;\n        margin: 15px 0;\n      }\n    }\n  }\n\n  // footer\n  footer.virtual-footer {\n  p {\n    font-size: 20px;\n  }\n  .pseudo-link {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n  .copyright {\n    font-size: 10px;\n  }\n}\n\n  // closing detail modal\n  .closing-details {\n    .event-eval-btn {\n      margin-top: 10px;\n    }\n    .upcoming-event-row {\n      .container {\n        .event-image {\n          display: none;\n        }\n        grid-template-columns: inherit;\n        .register-button-container {\n          button.btn.btn-danger {\n            margin: auto;\n            margin-bottom: 10px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.bad-token {\n  input {\n    width: 75%;\n    margin-bottom: 10px;\n  }\n}\n\n/* ZOOM CSS */\n#zmmtg-root {\n  display: none;\n}\n#wc-content {\n  height: calc(100% - 122px) !important;\n  bottom: -118px;\n}\n#wc-container-right {\n  height: calc(100vh - 153px) !important;\n}\n\n.ReactVirtualized__Grid.ReactVirtualized__List.chat-virtualized-list{\n  max-height: calc(100vh - 285px) !important; // need to set dynamically through browser hight - header & footer offset\n}\n.ReactVirtualized__Grid__innerScrollContainer {\n  max-height: calc(100vh - 320px) !important;\n  overflow-y: scroll !important;\n}\n.active-video-container__wrap {\n  height: calc(100vh - 200px);\n}\n\n// zoom misc.\n.audio-option-menu,\n.video-option-menu {\n  display: none !important;\n}\n.footer-button__button-label {\n  color: white;\n}\n#moreButton {\n  display: none;\n}\n.send-video-container button,\n.join-audio-container button{\n  color: #ffffff;\n}\n// timeslot styling\n.session-timeslots {\n  color: $medium-light-gray;\n  font-size: $smaller;\n  border-top: 1px dashed $medium-light-gray;\n  padding: 12px;\n  width: 100%;\n  display: grid;\n  grid-template-columns: 20% 65% 15%;\n  position: relative;\n  top: -26px;\n  background: #ffffff;\n  box-shadow: 2px 2px 8px 0px #bfbdbd;\n  height: 6rem;\n  .full-name {\n    font-weight: 900;\n    font-size: $small;\n  }\n  .btn-cancel{\n    border: 1px solid $medium-light-gray;\n  }\n  .timeslot-btn-div {\n    display: grid;\n  }\n  .timeslot-btn{\n    align-self: center;\n    padding: 5px 15px;\n    margin: 0 10px;\n    font-size: 14px;\n    &.btn-cancel {\n      border: 2px solid $solar;\n      padding: 5px 30px;\n      color: $solar;\n      &:hover{\n        border-color: $solar-secondary;\n        background-color: $solar-secondary;\n        color: #ffffff;\n      }\n    }\n    &.btn-danger {\n      color: #ffffff;\n    }\n  }\n  .add-to-calendar {\n    width: 50%;\n    font-size: 14px;\n    color: $vp-dark-gray;\n    &:hover {\n      cursor: pointer;\n      text-decoration: none;\n    }\n    .fa {\n      margin-right: 10px;\n    }\n  }\n}\n.wizard-links{\n  margin-bottom: 20px;\n  width: 100%;\n  float: left;\n  .link-divider {\n    color: $evanta-blue;\n    font-weight: 100;\n    line-height: 5px;\n    position: relative;\n    top: -3px;\n    float: left;\n    border-left: 2px solid $evanta-blue;\n    width: 2px;\n    height: 41px;\n    display: block;\n    margin: 0 12px;\n  }\n  .profile-nav{\n    float: left;\n    .active{\n      position: relative;\n    }\n    a:hover {\n      text-decoration: none;\n    }\n  }\n  .wizard-nav {\n    display: grid;\n    grid-template-columns: 2fr 2fr 2fr;\n    border: 2px solid $evanta-blue;\n    border-radius: 3px;\n    float: left;\n    color: $evanta-blue;\n    a, div {\n      text-align: center;\n      white-space: pre;\n      padding: 3px 15px;\n    }\n  }\n  a{\n    color: $medium-light-gray;\n    &.my-details {\n      border: 2px solid $evanta-blue;\n      color: $evanta-blue;\n      background: #ffffff;\n      padding: 3px 15px;\n      border-radius: 3px;\n      float: left;\n      &.active {\n        background-color: $evanta-blue;\n        color: #ffffff;\n      }\n    }\n  }\n  .active{\n    background-color: $evanta-blue;\n    color: #ffffff;\n  }\n}\n\n.wizard-form{\n  margin-top: 10px;\n  input, textarea {\n    width: 100%;\n    border: 1px $medium-light-gray solid;\n    border-radius: 3px;\n    color: $medium-dark-gray;\n  }\n  h4 {\n    color: $vp-black\n  }\n  p {\n    color: $vp-dark-gray;\n  }\n  .bottom-buttons {\n    text-align: center;\n  }\n  .rounded-circle {\n    margin-right: 5px;\n  }\n  .submit{\n    color: #ffffff;\n    background-color: $solar;\n    width: 200px;\n    border: 2px solid $solar;\n    &:disabled{\n      background-color: $light-gray;\n      background-color: $light-gray;\n      i {\n        margin-right: 10px;\n      }\n    }\n    &:focus{\n      outline: none;\n    }\n    &.previous{\n      color: $solar;\n      background: #ffffff;\n      border: 2px solid $solar;\n    }\n  }\n  .lps {\n    width: 345px;\n  }\n  label {\n    color: $medium-light-gray;\n    font-weight: normal;\n    display: block;\n    margin-bottom: 0;\n  }\n}\n\n@media only screen and (max-width: 585px) {\n  .wizard-links .link-divider {\n    display: none;\n  }\n  .wizard-links .wizard-nav {\n    display: block;\n    margin-top: 10px;\n  }\n  .wizard-links a.my-details, .wizard-links .profile-nav {\n    float: none;\n  }\n  .wishlist-rank-page .wishlistDraggable {\n    text-align: center;\n    display: block;\n    .action-button {\n      margin-top: 5px;\n    }\n  }\n  .react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal {\n    min-height: 300px;\n    .button-container button {\n      margin-top: 0px;\n    }\n  }\n}\n\n@media only screen and (max-width: 992px) {\n  .wizard-links a.my-details, .wizard-links .wizard-nav a, .wizard-links .wizard-nav div {\n    padding: 3px;\n    font-size: 12px;\n  }\n  .wizard-links .link-divider {\n    height: 36px;\n  }\n}\n\n","// Font colors\n$success-color: #38bb15;\n$warning-color: #feb52b;\n$error-color: #ff2e2e;\n$link-color: #428bca;\n\n$blue: #2d7cbf;\n$blue-light-gray: #d4e4e9;\n\n$lightest-gray: #f2f2f2;\n$light-gray: #eaeaea;\n$medium-lightest-gray: #dcdcdc;\n$medium-light-gray: #909092;\n$medium-gray: #c0c0c0;\n$medium-dark-gray: #606060;\n$dark-gray: #404040;\n\n$teal: #32c3b5;\n$gold: #f2b130;\n\n$eblack: #282829;\n$egrey: #dcddde;\n$evanta-blue: #4330ff;\n$evanta-blue-secondary: #5c4ee5;\n$gartner-blue: #002856;\n$active-slider: #3fe85c;\n$solar: #fa504b;\n$solar-secondary: #fb736f;\n\n\n// Font sizes\n$biggest-header: 36px;\n$big-header: 28px;\n$larger: 20px;\n$large: 16px;\n$medium: 14px;\n$small: 13px;\n$smaller: 12px;\n$tiny: 11px;\n\n// Homepage colors\n// $goldLight: #F9D889;\n// $goldPrimary: #F4B213;\n// $goldDark: #92451C;\n// $greenLight: #CDE3A5;\n// $greenPrimary: #9CC84B;\n// $greenDark: #416428;\n// $mintLight: #95E1DA;\n// $mintPrimary: #2BC4B6;\n// $mintDark: #00566B;\n// $purpleLight: #C6B1D4;\n// $purplePrimary: #8D64AA;\n// $purpleDark: #46295B;\n\n$goldLight: #F9D783;\n$goldPrimary: #92451C;\n$goldDark: #F5B51D;\n$greenLight: #C7E09A;\n$greenPrimary: #416428;\n$greenDark: #A0CA51;\n$mintLight: #8EDFD8;\n$mintPrimary: #02576C;\n$mintDark: #33C7B9;\n$purpleLight: #C3ADD2;\n$purplePrimary: #513465;\n$purpleDark: #9068AD;\n\n\n// virtual portal colors\n$vp-dark-gray: #6D6E71;\n$vp-black: #2C2C2C;\n$vp-bright-red: #FA504B;\n$vp-dark-gray-50op: rgba(109, 110, 113, 0.5)\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
